import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const r = await login(email, password);
    setBusy(false);
    if (r.ok) nav("/");
    else setErr(r.error);
  };

  return (
    <div className="max-w-md mx-auto px-4 py-10 sm:py-16">
      <div className="text-xs font-mono uppercase tracking-widest text-red-500 mb-1">Locker Room</div>
      <h1 className="font-display text-3xl sm:text-5xl font-black uppercase">Sign In</h1>
      <form onSubmit={submit} className="mt-6 space-y-4">
        <div>
          <Label>Email</Label>
          <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            data-testid="login-email" className="bg-slate-950 border-slate-700 h-11" />
        </div>
        <div>
          <Label>Password</Label>
          <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            data-testid="login-password" className="bg-slate-950 border-slate-700 h-11" />
        </div>
        {err && <div className="text-red-400 text-sm" data-testid="login-error">{err}</div>}
        <Button type="submit" disabled={busy} data-testid="login-submit"
          className="w-full h-11 bg-red-600 hover:bg-red-500 text-white font-bold uppercase tracking-wide">
          {busy ? "Ringing bell…" : "Enter the Ring"}
        </Button>
      </form>
      <p className="mt-4 text-sm text-slate-400">
        New here? <Link to="/register" className="text-red-500 font-semibold" data-testid="link-register">Create an account</Link>
      </p>
    </div>
  );
}
